import { Action, Dispatch } from 'redux'
import { FirebaseTimestamp } from 'firebase/index'
import { StoreTimesale } from 'types/storeTimesale'
import { fetchStoreTimesaleAction } from 'reducks/storeTimesale/actions'
import { State } from 'index'

const endStoreTimesale = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const storeTimesale = getState().storeTimesale.storeTimesale
    const now = FirebaseTimestamp.now()
    const { ref, ...rest } = storeTimesale
    if (!ref) return
    const nextStoreTimesale: StoreTimesale = {
      ...rest,
      end_at: now,
      is_active: false,
      updated_at: now,
    }
    return ref
      .set(nextStoreTimesale, { merge: true })
      .then(() => {
        nextStoreTimesale.ref = ref
        dispatch(fetchStoreTimesaleAction(nextStoreTimesale))
      })
      .catch((error: unknown) => {
        console.error(error)
      })
  }
}

export default endStoreTimesale
